import request from "lib/axio-utilis";
import { getUserDetail } from "utils/getUserDetailsHelper";
import { toDayRangeISO } from "utils/dateRangeHelper";

const catalogAPIs = {
  createCatalog: (data) => {
    return request({ url: "/api/v1/catalog/createCatalog", method: "post", data: data });
  },
  editCatalog: (data) => {
    return request({ url: "/api/v1/catalog/updateCatalogDesignWithArchive", method: "post", data: data });
  },
  getAllCatalogs: async ({ queryKey, pageParam = 1 }) => {
    const { limit, sortBy, search, isArchive, createdBy, designCount, startDate, endDate, } = queryKey[1];
    const userId = sortBy === "createdByMe" ? getUserDetail("_id") : null;
    const requestData = {
      page: pageParam,
      limit: limit,
      sortBy: sortBy,
      search: search,
      userId: userId,
      isArchive: isArchive,
      createdBy,
      designCount,
      startDate,
      endDate,
    };
    let response;
    if (!isArchive) {
      response = await request({ url: "/api/v1/catalog/getAllCatalogs", method: "post", data: requestData });
    } else {
      response = await request({ url: "/api/v1/catalog/getAllArchiveCatalogsForWeb", method: "post", data: requestData });
    }

    if (response.status !== 200) {
      throw new Error("Error fetching categories");
    }

    return {
      // catalogs: response.data.catalogs.filter((item) => item.isArchive === isArchivefilter),
      catalogs: response.data.catalogs,
      cardData: response.data.cardData,
      nextPage: response.data.pageNumber,
      totalPage: response.data.totalPages,
      totalCatalogs: response.data.totalCatalogs,
    };
  },
  getSingleCatalogProducts: async ({ queryKey, pageParam = 1 }) => {
    const { catalogId, limit, search, isArchive ,sortBy , order , filterBy, isHidden} = queryKey[1];
    const designCreateDate = toDayRangeISO(filterBy?.["Design Create Date"]);
    const requestData = {
      catalogId: catalogId,
      page: pageParam,
      limit: limit,
      search: search,
      sortBy: sortBy,
      order: order,
      filterBy: filterBy ? { ...filterBy, "Design Create Date": designCreateDate } : filterBy,
      isHidden,
    };
    
     let response;
     if (!isArchive) {
       response = await request({ url: "/api/v1/catalog/getDesignsByCatalogId", method: "post", data: requestData });
     } else {
       response = await request({ url: "/api/v1/catalog/getDesignsByArchiveCatalogId", method: "post", data: requestData });
     }
  
    if (response.status !== 200) {
      throw new Error("Error fetching categories");
    }

    return {
      catalogProducts: response.data.designs,
      nextPage: response.data.currentPage,
      totalPage: response.data.totalPages,
      totalDesigns: response.data.totalDesigns,
    };
  },
  catalogArchiveToUnarchive: (data) => {
    return request({ url: "/api/v1/catalog/catalogArchiveToUnarchive", method: "post", data: data });
  },
  catalogDelete: (data) => {
    return request({ url: "/api/v1/catalog/deleteCatalog", method: "post", data: data });
  },
};

export default catalogAPIs;
